// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 860 ? "29ac1dc2" : chunkId) + "." + {"843":"259072955d1739ac","860":"7ca948f7af4620d4"}[chunkId] + ".js";
};